import { z } from "zod";

export enum SystemErrorCodes {
    USER_HAS_MULTIPLE_ORGANIZATIONS = "user_has_multiple_organizations",
}

export const ErrorMessageSchema = z.object({
    message: z.string(),
    // Populated by backend error envelopes when available.
    traceId: z.string().nullable().optional(),
});

/** Schema for 500 responses that include an error code (e.g. getOrganization). */
export const ErrorResponseSchema = z.object({
    message: z.string(),
    errorCode: z.nativeEnum(SystemErrorCodes),
});
